export const DOC_TYPES = [
  "Capability Statement", "Contract Award Summary", "Past Performance Summary",
  "Key Personnel Resume", "SOW", "Compliance Certification", "Other",
];
export const MARKINGS = ["U", "CUI", "CUI//SP-PROPIN", "CUI//SP-PRVCY", "CUI//SP-CTI"];
export const MARKING_LABELS = {
  "U": "(U) Unclassified",
  "CUI": "(CUI) Controlled",
  "CUI//SP-PROPIN": "CUI//SP-PROPIN (proprietary)",
  "CUI//SP-PRVCY": "CUI//SP-PRVCY (privacy)",
  "CUI//SP-CTI": "CUI//SP-CTI (controlled tech)",
};
export const PP_HEALTH = ["", "Compliant", "Limited", "Incomplete"];
export const RELATIONSHIPS = ["", "Our Org", "Partner", "Prime", "Sub", "Vendor", "Client"];
export const AGENCY_TIERS = ["Federal", "SLED", "Other"];

export const markingClass = (m) =>
  m === "U" || !m ? "bg-zinc-100 text-zinc-600" : "bg-red-100 text-red-700";
